export enum KfmProcessType {
  Order = 1,
  Offer = 2,
  Invoice = 3,
}
